import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0003',
    ecrans: ['00-2'],
    params: ['?moecleint',
             '?indfor']
});
